import * as React from "react";
import { isOnScreen, scrollToElement } from "../../helpers/helper/index.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
const CollapseContext = React.createContext({
  id: "id-0",
  isVisible: false,
  onClose: (
    /* istanbul ignore next */
    () => null
  ),
  onOpen: (
    /* istanbul ignore next */
    () => null
  ),
  onRest: (
    /* istanbul ignore next */
    () => null
  ),
  onToggle: (
    /* istanbul ignore next */
    () => null
  ),
  triggerRef: (
    /* istanbul ignore next */
    () => null
  )
});
const CollapseProvider = (props) => /* @__PURE__ */ React.createElement(PropsChecker, { componentName: "CollapseProvider", componentProps: props, defaultValueName: "defaultIsVisible", valueName: "isVisible", onChangeNames: "onToggle" }, /* @__PURE__ */ React.createElement(CollapseProviderInner, { ...props }));
const CollapseProviderInner = (props) => {
  const { id, defaultIsVisible = false, isVisible: externalIsVisible, onToggle, triggerRef, portal, children } = props;
  const [isVisible, setIsVisible] = React.useState(defaultIsVisible);
  const [trigger, setTrigger] = React.useState(null);
  const isExternal = externalIsVisible !== void 0 && onToggle;
  const collapseContextValue = React.useMemo(() => {
    const isCollapseVisible = () => isExternal ? !!externalIsVisible : isVisible;
    const handleRest = () => {
      if (isCollapseVisible() && !isOnScreen(id)) {
        scrollToElement(id);
      }
    };
    const setVisible = (visible) => {
      if (!isExternal) {
        setIsVisible(visible);
      }
      onToggle == null ? void 0 : onToggle(visible);
    };
    const toggleVisibility = () => {
      setVisible(!isCollapseVisible());
    };
    const openCollapse = () => {
      setVisible(true);
    };
    const closeCollapse = () => {
      setVisible(false);
    };
    const setTriggerElement = (element) => {
      triggerRef == null ? void 0 : triggerRef(element);
      setTrigger(element);
    };
    return {
      id,
      isVisible: isCollapseVisible(),
      onClose: closeCollapse,
      onOpen: openCollapse,
      onRest: handleRest,
      onToggle: toggleVisibility,
      portal,
      trigger,
      triggerRef: setTriggerElement
    };
  }, [id, isVisible, externalIsVisible, isExternal, onToggle, trigger, portal, triggerRef]);
  return /* @__PURE__ */ React.createElement(CollapseContext.Provider, { value: collapseContextValue }, children);
};
export {
  CollapseContext,
  CollapseProvider
};
